(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-seo"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll(`[data-collection-seo-toggle]`).forEach(ele  => {

      ele.addEventListener('click', function(evt){
        const toggle = evt.target;
        const seoContent = ele.closest(`[data-collection-seo-content]`);
        console.log( {
          'toggle': toggle,
          'seoContent': seoContent,
       });
       seoContent.classList.toggle(`collapsed`);
       if( seoContent.classList.contains(`collapsed`) ){
          toggle.innerHTML = 'Read more';
       } else {
          toggle.innerHTML = 'Read less';
       }
      }.bind(this));
    });
  }())

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popups"]) return;
  try {
    
  (function(){
    /*
    document.querySelectorAll(`[data-collection-seo-toggle]`).forEach(ele  => {

      ele.addEventListener('click', function(evt){
        const toggle = evt.target;
        const seoContent = ele.closest(`[data-collection-seo-content]`);
        console.log( {
          'toggle': toggle,
          'seoContent': seoContent,
       });
       seoContent.classList.toggle(`collapsed`);
       if( seoContent.classList.contains(`collapsed`) ){
          toggle.innerHTML = 'Read more';
       } else {
          toggle.innerHTML = 'Read less';
       }
      }.bind(this));
    });
    */
  }())

  } catch(e) { console.error(e); }
})();
})();
